import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { Box, IconButton, Menu, useTheme } from '@mui/material';
import { useNavigate } from 'react-router';
import useToggle from '../../hooks/use-toggle';

import { TOGGLE_LIST_MENU } from '../../constants/global';

import { useLocation } from 'react-router-dom';
import IconClose from '../../components/Icons/IconClose';
import IconHamburgerMenu from '../../components/Icons/IconHamburgerMenu';
import Typography from '../../components/Typography';
import NavigationContainer from './styles';

import { useTranslation } from 'react-i18next';
import { TEXT_TRANSFORM, VARIANT_TYPOGRAPHY } from '../../enums';
import SolutionMenu from '../TopNavigation/SolutionMenu';

const NavigationMenu = ({ pages }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n } = useTranslation();

  const [anchorEl, setAnchorEl] = useState(null);

  const [isLanguageActive, setIsLanguageActive] = useState(false);
  const [language, setLanguage] = useState('ENG');

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
    // console.log(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const { toggle, toggleClickOpen, toggleClickClose } = useToggle({
    toggleList: TOGGLE_LIST_MENU,
  });

  const onChangeLanguage = (lang) => {
    i18n.changeLanguage(lang);

    const language = lang === 'ENG' ? 'en-US' : 'ko-KR';
    setLanguage(lang)
    i18n.changeLanguage(language);
    setAnchorEl(lang.currentTarget);
    setIsLanguageActive(false);
    toggleClickClose('navLanguageOptions');
  };

  return (
    <NavigationContainer maxWidth="xl">
      {/* Navigation links for larger screens */}
      <Box sx={{ flexGrow: 1, display: { xs: 'none', sm: 'none', md: 'none', lg: 'flex', xl: 'flex' } }} paddingRight={0} marginLeft={30}>
        {pages.map((page, index) => {
          const isActive = location.pathname === page.path || page.subPath?.includes(location.pathname);
          return (
            <Box padding={'5px 18px'}>
              {page.hasMenu ? (
                <SolutionMenu
                  toggle={toggle.solutionMenu}
                  toggleClose={() => toggleClickClose('solutionMenu')}
                  toggleOpen={(e) => toggleClickOpen(e, 'solutionMenu')}
                  isActive={isActive}
                />
              ) : (
                <Typography
                  key={index}
                  fontWeight={500}
                  label={page.label}
                  variant={VARIANT_TYPOGRAPHY.H6}
                  onClick={() => navigate(page.path)}
                  // style={{ padding: '5px 20px' }}
                  textTransform={TEXT_TRANSFORM.CAPITALIZE}
                  color={theme.palette.text.secondary}
                  sx={{
                    // padding: '5px 20px',
                    color: isActive ? '#9340BF' : '#FFFFFF', // Highlight active link
                    fontFamily: 'Open Sans',
                    fontWeight: '700 !important',
                    position: 'relative',
                    textTransform: 'none',
                    fontSize: '16px',
                    borderBottom: isActive ? '2px solid #5B3EDE' : '2px solid transparent',
                    '&:hover': {
                      borderBottom: '2px solid #5B3EDE',
                      color: '#9340BF',
                    },
                  }}
                />
              )}
            </Box>
          );
        })}
      </Box>
      {/* Hamburger Menu for smaller screens */}
      <IconButton
        edge="end"
        color="inherit"
        aria-label="menu"
        onClick={handleMenuOpen}
        sx={{
          display: {
            xs: 'block',
            sm: 'block',
            md: 'block',
            lg: 'none',
            xl: 'none',
            position: 'absolute !important',
            zIndex: 999,
            right: Boolean(anchorEl) ? '19px !important' : '16px !important',
            top: '22px !important',
          },
        }}
      >
        {Boolean(anchorEl) ? <IconClose fill="#fff" /> : <IconHamburgerMenu fill="#fff" />}
      </IconButton>
      {/* Dropdown Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        keepMounted
        sx={{
          display: {
            xs: 'block',
            sm: 'block',
            md: 'block',
            lg: 'none',
            xl: 'none',
            '& .MuiPaper-root': {
              width: '100% !important',
              height: '100% !important',
              background: '#000000 !important',
              left: '0 !important',
              top: '80px !important',
              boxShadow: 'none',
              minWidth: '100% !important',
              minHeight: '100% !important',
            },
          },
        }}
      >
        {pages.map((page, index) => {
          const isActive = location.pathname === page.path || page.subPath?.includes(location.pathname);
          const [isSubPathActive, setIsSubPathActive] = useState(false);
          return (
            <Box
              sx={{
                width: '90px',
                padding: '0 20px',
              }}
            >
              <Typography
                key={index}
                fontWeight={700}
                label={page.label}
                variant={VARIANT_TYPOGRAPHY.H6}
                onClick={() => {
                  if (page.subPath.length > 0) {
                    setIsSubPathActive(true);
                  } else {
                    navigate(page.path);
                  }
                }}
                style={{
                  padding: '10px 0px',
                  fontSize: '18px',
                  color: isActive ? '#9340BF' : '#FFFFFF',
                  borderBottom: isActive ? '4px solid #5B3EDE' : '2px solid transparent',
                  '&:hover': {
                    borderBottom: '2px solid #5B3EDE',
                    color: '#9340BF',
                  },
                  display: 'inline-block',
                  width: 'max-content',
                }}
                textTransform={TEXT_TRANSFORM.CAPITALIZE}
                color={theme.palette.text.secondary}
              />
              {page.subPath.length > 0 &&
                isSubPathActive &&
                ['white-label', 'all-in-one-service', 'turnkey'].map((item, i) => (
                  <Typography
                    key={i}
                    fontWeight={700}
                    label={item}
                    variant={VARIANT_TYPOGRAPHY.H6}
                    onClick={() => navigate(page.subPath[i])}
                    style={{
                      padding: '10px 15px',
                      fontSize: '18px',
                      color: '#FFFFFF',
                      // color: index === 0 ? '#9340BF' : '#000000',
                      // borderBottom: index === 0 ? '4px solid #5B3EDE' : '2px solid transparent',
                    }}
                    textTransform={TEXT_TRANSFORM.CAPITALIZE}
                    color={theme.palette.text.secondary}
                  />
                ))}
            </Box>
          );
        })}
        <Box
          sx={{
            width: '90px',
            padding: '0 20px',
          }}
        >
          <Typography
            key={5}
            fontWeight={700}
            label={language}
            variant={VARIANT_TYPOGRAPHY.H6}
            onClick={() => {
              // if (page.subPath.length > 0) {
              //   setIsSubPathActive(true);
              // } else {
              //   navigate(page.path);
              // }
              setIsLanguageActive(true);
            }}
            style={{
              padding: '10px 0px',
              fontSize: '18px',
              color: '#FFFFFF',
              // color: isActive ? '#9340BF' : '#FFFFFF',
              // borderBottom: isActive ? '4px solid #5B3EDE' : '2px solid transparent',
              '&:hover': {
                borderBottom: '2px solid #5B3EDE',
                color: '#9340BF',
              },
            }}
            textTransform={TEXT_TRANSFORM.CAPITALIZE}
            color={theme.palette.text.secondary}
          />
          {isLanguageActive &&
            ['ENG', '한국어'].map((item, i) => (
              <Typography
                key={i}
                fontWeight={700}
                label={item}
                variant={VARIANT_TYPOGRAPHY.H6}
                onClick={() => onChangeLanguage(item)}
                style={{
                  padding: '10px 15px',
                  fontSize: '18px',
                  color: '#FFFFFF',
                  // color: index === 0 ? '#9340BF' : '#000000',
                  // borderBottom: index === 0 ? '4px solid #5B3EDE' : '2px solid transparent',
                }}
                textTransform={TEXT_TRANSFORM.CAPITALIZE}
                color={theme.palette.text.secondary}
              />
            ))}
        </Box>
      </Menu>
    </NavigationContainer>
  );
};

NavigationMenu.propTypes = {
  pages: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      path: PropTypes.string,
    }),
  ),
};

export default NavigationMenu;
